(function () {
  'use strict'

  var CHECKBOX_ICON_SVG =
    '<svg class="cbb-fbt-row-checkbox-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 9" aria-hidden="true" focusable="false">' +
    '<path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M1 4.5L4.5 8L11 1"/>' +
    '</svg>'
  var FORM_READY_DELAY = 250
  var POLL_INTERVAL = 300
  var POLL_MAX = 60

  function dispatchChange (target) {
    var evt
    try {
      evt = new Event('change', { bubbles: true })
    } catch (e) {
      evt = document.createEvent('Event')
      evt.initEvent('change', true, true)
    }
    target.dispatchEvent(evt)
  }

  function getProductSubtitle (title) {
    var text = (title || '').trim()
    if (!text) return ''
    if (text.indexOf('|') !== -1) return text.split('|')[0].trim()
    if (/gel polish set/i.test(text)) return 'Gel Polish Set'
    if (/gel polish/i.test(text)) return '6 Colors Gel Polish Set'
    if (/nail lamp/i.test(text)) return 'Nail Lamp'
    if (/gift box/i.test(text)) return 'Gift Box'
    return ''
  }

  function setButtonLabel (button) {
    if (!button) return
    var label = 'Add Selected To Bag'
    if (button.tagName === 'INPUT') {
      button.value = label
      return
    }
    var span = button.querySelector('.translatable')
    if (span) {
      span.textContent = label
    } else {
      button.textContent = label
    }
  }

  function ensureTotalLineShell (totalLine) {
    if (totalLine.querySelector('.cbb-fbt-bottom-total-amounts')) return
    totalLine.innerHTML =
      '<span class="cbb-fbt-bottom-total-prefix">Total Price: </span>' +
      '<span class="cbb-fbt-bottom-total-amounts"></span>' +
      '<span class="cbb-fbt-bottom-total-suffix"> Add Selected To Cart</span>'
  }

  function refreshBottomTotal (form, totalLine) {
    ensureTotalLineShell(totalLine)
    var amounts = totalLine.querySelector('.cbb-fbt-bottom-total-amounts')
    if (!amounts) return

    var live = []
    var all = form.querySelectorAll('.money')
    for (var i = 0; i < all.length; i++) {
      if (!totalLine.contains(all[i])) live.push(all[i])
    }
    var currentHtml = live[0] ? (live[0].outerHTML || '') : ''
    var compareHtml = live[1] ? (live[1].outerHTML || '') : ''
    if (compareHtml) compareHtml = ' <s>' + compareHtml + '</s>'
    amounts.innerHTML = currentHtml + compareHtml
  }

  function markSourceMoneyHidden (form, totalLine) {
    var all = form.querySelectorAll('.money')
    for (var i = 0; i < all.length; i++) {
      var el = all[i]
      if (totalLine.contains(el)) {
        el.removeAttribute('data-cbb-fbt-source')
        continue
      }
      el.setAttribute('data-cbb-fbt-source', 'true')
    }
  }

  function scheduleTotalRefresh (container) {
    var form = container.querySelector('.cbb-frequently-bought-form')
    var totalLine = form && form.querySelector('.cbb-fbt-bottom-total')
    if (!form || !totalLine) return
    function run () {
      refreshBottomTotal(form, totalLine)
      markSourceMoneyHidden(form, totalLine)
    }
    run()
    setTimeout(run, 50)
    setTimeout(run, 200)
  }

  function getRecommendedBlogsSection () {
    var sectionWrapper = document.querySelector('.shopify-section.section-product-recommended-blogs')
    if (sectionWrapper) return sectionWrapper

    var sectionRoot = document.querySelector('.product-recommended-blogs')
    if (!sectionRoot) return null

    return sectionRoot.closest('.shopify-section') || sectionRoot
  }

  function placeRecommendedBlogs (container) {
    if (!container) return

    var blogsSection = getRecommendedBlogsSection()
    if (!blogsSection || blogsSection.contains(container)) return

    var stack = container.closest('.cbb-fbt-sidebar-stack')
    if (!stack) {
      stack = document.createElement('div')
      stack.className = 'cbb-fbt-sidebar-stack'
      container.parentNode.insertBefore(stack, container)
      stack.appendChild(container)
    }

    var root = blogsSection.querySelector('.product-recommended-blogs') || blogsSection
    blogsSection.classList.add('section-product-recommended-blogs--fbt-placement')
    root.classList.add('product-recommended-blogs--fbt-placement')

    if (blogsSection.parentNode === stack && blogsSection.previousElementSibling === container) return

    stack.appendChild(blogsSection)
  }

  function enhanceForm (container) {
    var form = container.querySelector('.cbb-frequently-bought-form')
    if (!form || form.classList.contains('cbb-fbt-enhanced')) return true

    var button = form.querySelector('button, input[type="submit"]')
    var moneyEls = form.querySelectorAll('.money')
    if (!button || !moneyEls.length) return false

    container.appendChild(form)
    form.classList.add('cbb-fbt-enhanced')
    setButtonLabel(button)

    var totalLine = document.createElement('div')
    totalLine.className = 'cbb-fbt-bottom-total'

    form.insertBefore(button, form.firstChild)
    if (button.nextSibling) {
      form.insertBefore(totalLine, button.nextSibling)
    } else {
      form.appendChild(totalLine)
    }

    if (!container.hasAttribute('data-cbb-fbt-total-refresh')) {
      container.setAttribute('data-cbb-fbt-total-refresh', '1')
      container.addEventListener('change', function (e) {
        var t = e.target
        if (!t || !t.classList || !t.classList.contains('cbb-frequently-bought-selector-input')) {
          return
        }
        scheduleTotalRefresh(container)
      })
    }
    scheduleTotalRefresh(container)

    var allNodes = container.querySelectorAll('*')
    for (var i = 0; i < allNodes.length; i++) {
      var el = allNodes[i]
      if (el === totalLine || el.contains(totalLine) || totalLine.contains(el)) continue
      if (el.textContent && /total price/i.test(el.textContent)) el.style.display = 'none'
    }
    return true
  }

  function buildRow (productLi, selectorLi) {
    var variantInput = selectorLi.querySelector('.cbb-frequently-bought-selector-input')
    if (!variantInput) return null

    variantInput.checked = true

    var titleEl = selectorLi.querySelector('.cbb-frequently-bought-selector-label-name')
    var titleText = titleEl ? (titleEl.textContent || '').trim() : ''
    var subtitleText = getProductSubtitle(titleText)
    var productLink = selectorLi.querySelector('.cbb-frequently-bought-selector-link')
    var productHref = productLink ? productLink.getAttribute('href') : ''

    var salePriceEl = selectorLi.querySelector('.cbb-frequently-bought-selector-label-sale-price')
    var regularPriceEl = selectorLi.querySelector('.cbb-frequently-bought-selector-label-regular-price')
    var compareEl = selectorLi.querySelector('.cbb-frequently-bought-selector-label-compare-at-price')
    var priceHtml = ''
    if (salePriceEl && salePriceEl.innerHTML) {
      priceHtml += salePriceEl.innerHTML
    } else if (regularPriceEl && regularPriceEl.innerHTML) {
      priceHtml += regularPriceEl.innerHTML
    }
    if (compareEl && compareEl.innerHTML) {
      priceHtml += ' <s>' + compareEl.innerHTML + '</s>'
    }

    var imageEl = productLi.querySelector('.cbb-frequently-bought-product-image')
    var imageLink = productLi.querySelector('.cbb-frequently-bought-product-image-link')
    var bgStyle = imageEl && imageEl.getAttribute('style') ? imageEl.getAttribute('style') : ''
    var imageHref = imageLink ? imageLink.getAttribute('data-href') || imageLink.getAttribute('href') : productHref

    var row = document.createElement('li')
    row.className = 'cbb-fbt-row'

    var imageWrap = document.createElement('div')
    imageWrap.className = 'cbb-fbt-row-image'
    if (bgStyle) imageWrap.setAttribute('style', bgStyle)

    var isChecked = !!variantInput.checked
    var checkboxBtn = document.createElement('button')
    checkboxBtn.type = 'button'
    checkboxBtn.className = 'cbb-fbt-row-checkbox' + (isChecked ? ' is-checked' : '')
    checkboxBtn.setAttribute('aria-pressed', isChecked ? 'true' : 'false')
    checkboxBtn.innerHTML = CHECKBOX_ICON_SVG
    imageWrap.appendChild(checkboxBtn)

    if (imageHref) {
      var a = document.createElement('a')
      a.href = imageHref
      a.setAttribute('tabindex', '0')
      imageWrap.appendChild(a)
    }
    row.appendChild(imageWrap)

    var info = document.createElement('div')
    info.className = 'cbb-fbt-row-info'

    var copyWrap = document.createElement('div')
    copyWrap.className = 'cbb-fbt-row-copy'

    if (subtitleText) {
      var subtitle = document.createElement('p')
      subtitle.className = 'cbb-fbt-row-subtitle'
      subtitle.textContent = subtitleText
      copyWrap.appendChild(subtitle)
    }

    var titleWrap = document.createElement('h3')
    titleWrap.className = 'cbb-fbt-row-title'
    if (productHref) {
      var titleLink = document.createElement('a')
      titleLink.href = productHref
      titleLink.setAttribute('tabindex', '0')
      titleLink.textContent = titleText
      titleWrap.appendChild(titleLink)
    } else {
      titleWrap.textContent = titleText
    }
    copyWrap.appendChild(titleWrap)
    info.appendChild(copyWrap)

    var priceWrap = document.createElement('div')
    priceWrap.className = 'cbb-fbt-row-price'
    priceWrap.innerHTML = priceHtml || ''
    info.appendChild(priceWrap)

    row.appendChild(info)

    checkboxBtn.addEventListener('click', function (e) {
      e.preventDefault()
      variantInput.checked = !variantInput.checked
      checkboxBtn.classList.toggle('is-checked', variantInput.checked)
      checkboxBtn.setAttribute('aria-pressed', variantInput.checked ? 'true' : 'false')
      dispatchChange(variantInput)
    })

    return row
  }

  function run () {
    var container = document.querySelector('.cbb-frequently-bought-container')
    if (!container) return true
    placeRecommendedBlogs(container)
    if (container.classList.contains('cbb-fbt-optimized')) return true

    var productsList = container.querySelector('.cbb-frequently-bought-products')
    var selectorList = container.querySelector('.cbb-frequently-bought-selector-list')
    if (!productsList || !selectorList) return false

    var productItems = productsList.querySelectorAll('.cbb-frequently-bought-product')
    var selectorItems = selectorList.querySelectorAll('li')
    var count = Math.min(productItems.length, selectorItems.length)
    if (count === 0) return false

    var recommendationsContainer = container.querySelector('.cbb-frequently-bought-recommendations-container')
    if (!recommendationsContainer) return false

    var existingRows = recommendationsContainer.querySelector('.cbb-fbt-rows')
    if (!existingRows) {
      var wrapper = document.createElement('ul')
      wrapper.className = 'cbb-fbt-rows'
      wrapper.setAttribute('role', 'list')

      for (var i = 0; i < count; i++) {
        var row = buildRow(productItems[i], selectorItems[i])
        if (row) wrapper.appendChild(row)
      }

      if (wrapper.children.length === 0) return false
      recommendationsContainer.appendChild(wrapper)

      var firstInput = selectorItems[0].querySelector('.cbb-frequently-bought-selector-input')
      if (firstInput) dispatchChange(firstInput)

      scheduleFormRetry(container)
    }

    var formReady = enhanceForm(container)
    if (formReady) {
      container.classList.add('cbb-fbt-optimized')
      placeRecommendedBlogs(container)
      return true
    }
    return false
  }

  function scheduleFormRetry (container) {
    if (!container || container.classList.contains('cbb-fbt-optimized')) return
    setTimeout(function () {
      if (container.classList.contains('cbb-fbt-optimized')) return
      if (enhanceForm(container)) {
        container.classList.add('cbb-fbt-optimized')
        placeRecommendedBlogs(container)
      }
    }, FORM_READY_DELAY)
  }

  function poll () {
    var container = document.querySelector('.cbb-frequently-bought-container')
    if (!container) return
    placeRecommendedBlogs(container)
    var done = run()
    if (done) return
    var attempts = 0
    var t = setInterval(function () {
      attempts++
      if (run() || attempts >= POLL_MAX) clearInterval(t)
    }, POLL_INTERVAL)
  }

  function init () {
    poll()
    var container = document.querySelector('.cbb-frequently-bought-container:not(.cbb-fbt-optimized)')
    if (container) scheduleFormRetry(container)
  }

  function start () {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init)
    } else {
      init()
    }

    if (typeof MutationObserver !== 'undefined') {
      var observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var nodes = mutations[i].addedNodes
          for (var j = 0; j < nodes.length; j++) {
            var node = nodes[j]
            if (node.nodeType !== 1) continue
            if (node.classList && node.classList.contains('cbb-frequently-bought-container')) {
              init()
              return
            }
            if (node.classList && node.classList.contains('section-product-recommended-blogs')) {
              init()
              return
            }
            if (node.querySelector && node.querySelector('.cbb-frequently-bought-container')) {
              init()
              return
            }
            if (node.querySelector && node.querySelector('.section-product-recommended-blogs')) {
              init()
              return
            }
          }
        }
      })
      var target = document.body
      if (target) {
        observer.observe(target, { childList: true, subtree: true })
      } else {
        document.addEventListener('DOMContentLoaded', function () {
          if (document.body) observer.observe(document.body, { childList: true, subtree: true })
        })
      }
    }
  }

  start()
})()
